import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Button } from '@spotahome/ui-library';

import './ImageBlock.scss';

const noop = () => {};

const ImageBlock = ({
  title,
  cta = null,
  renderImage = noop,
  className = ''
}) => {
  return (
    <div
      className={classNames('tenant-guarantees-help-image-block', className)}
    >
      <div className="tenant-guarantees-help-image-block__content">
        <h3 className="tenant-guarantees-help-image-block__title">{title}</h3>
        {cta && (
          <Button
            color="tertiary"
            size="large"
            href={cta.url}
            className="tenant-guarantees-help-image-block__cta"
          >
            {cta.text}
          </Button>
        )}
      </div>
      {renderImage()}
    </div>
  );
};

ImageBlock.propTypes = {
  title: PropTypes.string.isRequired,
  renderImage: PropTypes.func,
  cta: PropTypes.shape({
    url: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  }),
  className: PropTypes.string
};

export default ImageBlock;
